import React, { useState } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TextField,
  MenuItem,
  ListItemText,
  InputAdornment,
  Radio,
  FormControlLabel,
  Snackbar,
  Alert,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../formElements/InputField";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  createAccountGSTDetails,
  createAccountGroupMaster,
  createAccountMaster,
} from "../../graphql/mutations";
import {
  listAccountGroupMaster,
  listAccountMaster,
  getCompany,
  searchHSN,
} from "../../graphql/queries";
import AddPartyModal from "./AddPartyModal";
import AddBankAccount from "./AddBankAccount";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "500px",
};

const AddToAccount = ({
  open,
  setOpen,
  accountFlag,
  setsuccessSnakbar,
  setSnakbarText,
  setWarningSnakbar,
  accountName,
  setWarningText,
  setState1,
  msg,
  itemEntry,
  setNewAccID,
}) => {
  let randomNum = Math.floor(Math.random() * 100 + 1);
  let timeStamp = Math.floor(new Date().getTime() / 1000);
  let randomNumber = randomNum + timeStamp.toString().slice(3, 9);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [group, setGroup] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [openBankModal, setOpenBakModal] = useState(false);
  const [partyName, setPartyName] = useState("");
  const [partyType, setPartyType] = useState("");
  const [accName, setAccName] = useState("");
  const [companyData, setComapanyData] = useState([]);
  const [filterHSN, setFilterHSN] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [state, setState] = useState({
    group: { label: "", value: "", accountTypeCD: "" },
    name: "",
    hsnCode: { label: "", value: "" },
    gstrate: "",
    cess: "",
    cessType: "",
    errorStatus: {
      group: false,
      name: false,
      hsnCode: false,
      gstrate: false,
      cess: false,
      cessType: false,
    },
    errorFields: {
      group: "",
      name: "",
      hsnCode: "",
      cess: "",
      cessType: "",
      gstrate: "",
    },
  });
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      value = value
        ?.toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: false,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };
  async function listGroup() {
    const res = await API.graphql(graphqlOperation(listAccountGroupMaster));

    if (res.data.listAccountGroupMaster != null) {
      let accountGroup = [];
      let CBAccountGroup = [];
      res.data.listAccountGroupMaster.map((item) => {
        accountGroup.push({
          value: item.AccountGroupID,
          label: item.AccountGroupName,
          accountTypeCD: item?.AccountTypeCD,
        });
      });
      // let cashType = res.data.listAccountGroupMaster.filter(
      //   (item) => item.AccountGroupID.split(" ").indexOf(16) !== -1
      // );
      let cashType = res.data.listAccountGroupMaster.filter((item) => {
        if (item.AccountGroupID == 16) {
          return item;
        }
      });

      // let bankType = res.data.listAccountGroupMaster.filter(
      //   (item) => item.AccountGroupID.split(" ").indexOf(17) !== -1
      // );
      let bankType = res.data.listAccountGroupMaster.filter((item) => {
        if (item.AccountGroupID == 17) {
          return item;
        }
      });
      let mergType = cashType.concat(bankType);
      mergType.map((item) => {
        CBAccountGroup.push({
          label: item.AccountGroupID,
          value: item.AccountGroupID,
        });
      });
      // if (accountFlag === false) {
      //   setGroup(CBAccountGroup);
      // } else {
      setGroup(accountGroup);
      // }
    }
  }
  const getCompany = useSelector(
    (state) => state?.companyReducer.companyDetails
  );
  const companyLoaded = useSelector(
    (state) => state?.companyReducer.Loaded
  );
  async function getCompanyDetails() {
    try {
      setComapanyData({ getCompany });
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listLedgerData() {
    try {
      const res = await API.graphql(graphqlOperation(listAccountMaster));
      setLedger(res.data.listAccountMaster);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function searchSAC(value) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, { RowFrom: 0, LimitNo: 10000, Word: value })
      );
      console.log("res", res);
      if (res.data.searchHSN !== null) {
        let arr = [{ label: "", value: "" }];
        res.data.searchHSN?.map((item) => {
          arr.push({
            label: `${item.HSNSACCode} - ${item.Description}`,
            value: `${item.HSNSACCode}`,
          });
        });
        setFilterHSN(arr);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    if (open) {
      getCompanyDetails();
      listGroup();
      listLedgerData();
    }
  }, [open]);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setState((prev) => ({
        ...prev,
        group: { label: "", value: "", accountTypeCD: "" },
        name: "",
        hsnCode: { label: "", value: "" },
        cess: "",
        cessType: "",
        gstrate: "",
        errorStatus: {
          group: false,
          name: false,
          hsnCode: false,
          cess: false,
          cessType: false,
          gstrate: false,
        },
        errorFields: {
          group: "",
          name: "",
          hsnCode: "",
          cess: "",
          cessType: "",
          gstrate: "",
        },
      }));
      setLoading(false);
      setOpen(false);
    }
  };

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === "name") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Account Name is required";
          obj.errorStatus.name = true;
        } else {
          let uniqueValid = true
          ledger.map((item) => {
            if (item.AccountName.toLowerCase() == state.name.toLowerCase()) {
              uniqueValid = false;
            }
          });
          if (uniqueValid == false) {
            isvalid = false
            obj.errorFields.name = "Account Name already exists";
            obj.errorStatus.name = true;
          } else {
            obj.errorFields.name = "";
            obj.errorStatus.name = false;
          }
        }
      }

      if (key === "group") {
        if (data[key].value == 0) {
          isvalid = false;
          obj.errorFields.group = "Group is required";
          obj.errorStatus.group = true;
        } else {
          // isvalid=true;
          obj.errorFields.group = "";
          obj.errorStatus.group = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  async function saveNewAccounts(data) {
    try {
      if (
        state.group.value !== 7 &&
        state.group.value !== 15 &&
        state.group.value !== 17
      ) {
        const resledger = await API.graphql(
          graphqlOperation(createAccountMaster, {
            createAccountMasterInput: data,
          })
        );
        saveGstDetails(resledger?.data?.createAccountMaster?.AccountsID);
        if (resledger.data.createAccountMaster.StatusCode === "Error") {
          setWarningSnakbar(true);
          setLoading(false);
          setWarningText(resledger.data.createAccountMaster.StatusMessage);
        } else {
          if (resledger.data.createAccountMaster !== null) {
            setOpen(false);
            setsuccessSnakbar(true);
            if (setNewAccID) {
              setNewAccID(resledger?.data?.createAccountMaster?.AccountsID);
            }
            if (msg === "Payment") {
              setState1((prev) => ({
                ...prev,
                paidTo: {
                  label: resledger?.data?.createAccountMaster?.AccountName,
                  value: resledger?.data?.createAccountMaster?.AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  paidTo: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  paidTo: "",
                },
              }));
            }
            if (msg === "Receipt") {
              setState1((prev) => ({
                ...prev,
                receivedFrom: {
                  label: resledger?.data?.createAccountMaster?.AccountName,
                  value: resledger?.data?.createAccountMaster?.AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  receivedFrom: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  receivedFrom: "",
                },
              }));
            }
            if (msg === "Purchase") {
              if (itemEntry) {
                setState1((prev) => ({
                  ...prev,
                  purchaseAccount: {
                    label: resledger?.data?.createAccountMaster?.AccountName,
                    value: resledger?.data?.createAccountMaster?.AccountsID,
                  },
                }));
              } else {
                setState1((prev) => ({
                  ...prev,
                  ledgerAccount: {
                    label: resledger?.data?.createAccountMaster?.AccountName,
                    value: resledger?.data?.createAccountMaster?.AccountsID,
                  },
                }));
              }
            }
            if (msg === "Sales") {
              if (itemEntry) {
                setState1((prev) => ({
                  ...prev,
                  purchaseAccount: {
                    label: resledger?.data?.createAccountMaster?.AccountName,
                    value: resledger?.data?.createAccountMaster?.AccountsID,
                  },
                }));
              } else {
                setState1((prev) => ({
                  ...prev,
                  ledgerAccount: {
                    label: resledger?.data?.createAccountMaster?.AccountName,
                    value: resledger?.data?.createAccountMaster?.AccountsID,
                  },
                }));
              }
            }
            if (msg === "SalesNonTax") {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label: resledger?.data?.createAccountMaster?.AccountName,
                  value: resledger?.data?.createAccountMaster?.AccountsID,
                },
              }));
            }

            if (msg === "Debit") {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label: resledger?.data?.createAccountMaster?.AccountName,
                  value: resledger?.data?.createAccountMaster?.AccountsID,
                },
              }));
            }
            if (msg === "Credit") {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label: resledger?.data?.createAccountMaster?.AccountName,
                  value: resledger?.data?.createAccountMaster?.AccountsID,
                },
              }));
            }
            setSnakbarText("Account Added");
            setLoading(false);
            setState((prev) => ({
              ...prev,
              group: { label: "", value: "", accountTypeCD: "" },
              name: "",
              hsnCode: { label: "", value: "" },
              cess: "",
              cessType: "",
              gstrate: "",
              errorStatus: {
                group: false,
                name: false,
                hsnCode: false,
                cess: false,
                cessType: false,
                gstrate: false,
              },
              errorFields: {
                group: "",
                name: "",
                hsnCode: "",
                cess: "",
                cessType: "",
                gstrate: "",
              },
            }));
            setLoading(false);
          }
        }

        return resledger;
      } else if (state.group.value == 17) {
        if (
          msg === "Payment" ||
          msg === "Receipt" ||
          msg == "Purchase" ||
          msg == "Sales" ||
          msg == "Debit" ||
          msg == "Credit" ||
          msg == "SalesNonTax"
        ) {
          setOpen(false);
          setAccName(data.AccountName);
          setLoading(false);
          setOpenBakModal(true);
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: false,
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }
      } else {
        if (msg === "ManualJournal") {
          setState1((prev) => ({
            ...prev,
            account: {
              label: data?.AccountName,
              value: data?.AccountsID,
              AccountGroupID: data?.AccountGroupID,
            },
          }));

          setOpen(false);
          setsuccessSnakbar(true);
          setSnakbarText("Account Added");
          setLoading(false);
          if (state.group.value === 7) {
            setOpenPartyModal(true);
            setPartyName(data.AccountName);
            setPartyType("SUPPLIER");
          }
          if (state.group.value === 15) {
            setOpenPartyModal(true);
            setPartyName(data?.AccountName);
            setPartyType("CUSTOMER");
          }
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: "",
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }
        if (
          msg === "Debit" ||
          msg === "Credit" ||
          msg === "Sales" ||
          msg == "SalesNonTax"
        ) {
          setState1((prev) => ({
            ...prev,
            ledgerAccount: {
              label: data?.AccountName,
              value: data?.AccountsID,
              AccountGroupID: data?.AccountGroupID,
            },
          }));

          setOpen(false);
          setsuccessSnakbar(true);
          setSnakbarText("Account Added");
          setLoading(false);
          if (state.group.value === 7) {
            setOpenPartyModal(true);
            setPartyName(data.AccountName);
            setPartyType("SUPPLIER");
          }
          if (state.group.value === 15) {
            setOpenPartyModal(true);
            setPartyName(data?.AccountName);
            setPartyType("CUSTOMER");
          }
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: false,
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }
        if (msg === "Purchase") {
          if (itemEntry) {
            setState1((prev) => ({
              ...prev,
              purchaseAccount: {
                label: data?.AccountName,
                value: data?.AccountsID,
                AccountGroupID: data?.AccountGroupID,
              },
            }));
          } else {
            setState1((prev) => ({
              ...prev,
              ledgerAccount: {
                label: data?.AccountName,
                value: data?.AccountsID,
                AccountGroupID: data?.AccountGroupID,
              },
            }));
          }
          setOpen(false);
          setsuccessSnakbar(true);
          setSnakbarText("Account Added");
          setLoading(false);
          if (state.group.value === 7) {
            setOpenPartyModal(true);
            setPartyName(data.AccountName);
            setPartyType("SUPPLIER");
          }
          if (state.group.value === 15) {
            setOpenPartyModal(true);
            setPartyName(data?.AccountName);
            setPartyType("CUSTOMER");
          }
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: false,
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }
        if (msg === "Payment") {
          setState1((prev) => ({
            ...prev,
            paidTo: {
              label: data?.AccountName,
              value: data?.AccountsID,
              AccountGroupID: data?.AccountGroupID,
            },
          }));
          setOpenBakModal(true);

          setOpen(false);
          setsuccessSnakbar(true);
          setSnakbarText("Account Added");
          setLoading(false);
          if (state.group.value === 7) {
            setOpenPartyModal(true);
            setPartyName(data.AccountName);
            setPartyType("SUPPLIER");
          }
          if (state.group.value === 15) {
            setOpenPartyModal(true);
            setPartyName(data?.AccountName);
            setPartyType("CUSTOMER");
          }
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: false,
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }

        if (msg === "Receipt") {
          setState1((prev) => ({
            ...prev,
            receivedFrom: {
              label: data?.AccountName,
              value: data?.AccountsID,
              AccountGroupID: data?.AccountGroupID,
            },
          }));

          setOpen(false);
          setsuccessSnakbar(true);
          setSnakbarText("Account Added");
          setLoading(false);
          if (state.group.value === 7) {
            setOpenPartyModal(true);
            setPartyName(data.AccountName);
            setPartyType("SUPPLIER");
          }
          if (state.group.value === 15) {
            setOpenPartyModal(true);
            setPartyName(data?.AccountName);
            setPartyType("CUSTOMER");
          }
          setState((prev) => ({
            ...prev,
            group: { label: "", value: "", accountTypeCD: "" },
            name: "",
            hsnCode: { label: "", value: "" },
            cess: "",
            cessType: "",
            gstrate: "",
            errorStatus: {
              group: false,
              name: false,
              hsnCode: "",
              cess: false,
              cessType: false,
              gstrate: false,
            },
            errorFields: {
              group: "",
              name: "",
              hsnCode: "",
              cess: "",
              cessType: "",
              gstrate: "",
            },
          }));
        }
      }
    } catch (error) {
      // setSnakbarText("Account not Added");
      setLoading(false);
      console.log(error);
    }
  }
  async function saveGstDetails(accID) {
    try {
      const gstData = {
        AccountID: accID,
        EffectiveDate: Math.floor(new Date().getTime() / 1000),
        ExpiredDate: 0,
        GSTCompensationType: state.cessType,
        GSTRate: state.gstrate,
        HSNID: state.hsnCode.value == "" ? 0 : Number(state.hsnCode.value),
        CessAmount: state.cess == "" ? 0 : Number(state.cess)
      };
      const resGstData = await API.graphql(
        graphqlOperation(createAccountGSTDetails, {
          createAccountGSTDetailsInput: gstData,
        })
      );
      console.log("resGstData", resGstData);
      setBackdropOpen(false);
    } catch (error) {
      console.log(error);
      setBackdropOpen(false);
    }
  }
  async function saveChanges() {
    const { group, name, hsnCode, cess, cessType, gstrate } = state;
    const formData = {
      group,
      name,
      hsnCode,
      cess,
      cessType,
      gstrate,
    };
    if (formValidation(formData)) {
      setLoading(true);
      const LedgerData = {
        AccountGroupID: group.value,
        AccountName: name,
        AccountTypeCD: group?.accountTypeCD,
        HSNSACCode: Number(hsnCode.value),
      };
      saveNewAccounts(LedgerData);

      // Promise.resolve(response).then((value) => {
      //   console.log(value?.data?.createAccountMaster);
      //   let { AccountName, AccountsID } = value?.data?.createAccountMaster
      //   console.log(msg);
      // if(msg==="Payment"){

      //   setState1((prev) => ({
      //     ...prev,
      //     paidTo: { label: AccountName, value: AccountsID },
      //     errorStatus: {
      //       ...prev.errorStatus,
      //       paidTo: false,
      //     },
      //     errorFields: {
      //       ...prev.errorFields,
      //       paidTo: "",
      //     },
      //   }))
      // }
      // if(msg==="Receipt"){
      //   setState1((prev) => ({
      //     ...prev,
      //     receivedFrom: { label: AccountName, value: AccountsID },
      //     errorStatus: {
      //       ...prev.errorStatus,
      //       receivedFrom: false,
      //     },
      //     errorFields: {
      //       ...prev.errorFields,
      //       receivedFrom: "",
      //     },
      //   }))
      // }
      // if(msg==="Purchase"){
      //   if(itemEntry){
      //   setState1((prev) => ({
      //     ...prev,
      //     purchaseAccount: { label: AccountName, value: AccountsID },
      //   }))
      // }else{
      //   setState1((prev) => ({
      //     ...prev,
      //     ledgerAccount: { label: AccountName, value: AccountsID },
      //   }))
      // }
      // }
      // })
    }
  }

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Add New Account
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                backgroundColor: "white",
                padding: "15px",
                // height:{xs:"400px",sm:'auto'},
              }}
            >
              <Box sx={{}}>
                <Box sx={{ mb: 2 }}>
                  <InputField
                    required={true}
                    state={state}
                    name="name"
                    placeholder="Account"
                    size="small"
                    type="text"
                    value={state.name}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          errorFields: {
                            name: "Account Name is required",
                          },
                          errorStatus: {
                            name: true,
                          },
                        }));
                      } else {
                        let isvalid = true;
                        ledger.map((item) => {
                          if (item.AccountName.toLowerCase() == e.target.value.toLowerCase()) {
                            isvalid = false;
                          }
                        });
                        if (isvalid == false) {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "Account Name already exists",
                            },
                            errorStatus: {
                              name: true,
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "",
                            },
                            errorStatus: {
                              name: false,
                            },
                          }));
                        }
                      }
                    }}
                  />
                </Box>
                <Box sx={{}}>
                  {/* <TextField
                    error={state.errorStatus.group}
                    required={true}
                    select
                    //   disabled={true}
                    name="group"
                    label="Select Group"
                    variant="outlined"
                    value={state.group}
                    onChange={(e) => handleChange(e)}
                    size="small"
                    fullWidth
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-14qz1ij-MuiListItemText-root": {
                        margin: "0px",
                      },
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    {group.length > 0 ? (
                      group.map((item, ind) => {
                        return (
                          <MenuItem key={ind} value={item.value}>
                            <ListItemText sx={{ margin: "5px" }}>
                              {item.name}
                            </ListItemText>
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem key={"1"} value={"noitem"}>
                        {"No Item Found"}
                      </MenuItem>
                    )}
                  </TextField> */}
                  <Autocomplete
                    disablePortal
                    id="group"
                    disableClearable
                    options={group}
                    isOptionEqualToValue={(option, value) =>
                      option.value == value.value
                    }
                    value={state.group}
                    onChange={(e, newValue) => {
                      if (newValue === "") {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "Group  Field is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingBottom: "5px",
                      },
                      ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingTop: "6px",
                        paddingBottom: "5px",
                        paddingLeft: "6px",
                      },
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        error={state.errorStatus.group === true ? true : false}
                        sx={{
                          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: "8.5px 7px",
                          },
                          ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                          {
                            fontSize: "14px",
                          },
                          label: {
                            fontSize: "14px",
                          },
                          ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                            fontSize: "14px",
                          },
                          ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-14qz1ij-MuiListItemText-root": {
                            margin: "0px",
                          },
                          ".css-wgai2y-MuiFormLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        label="Group"
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.group}
                  </Typography>
                </Box>
              </Box>
              {state.group.value !== 17 && (
                <Accordion sx={{ mt: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ maxHeight: "auto" }}
                  >
                    <Typography
                      sx={{ color: "primary.main", fontWeight: "500" }}
                    >
                      GST Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          flex: { xs: 1, sm: 0.5 },
                          m: 1,
                          minWidth: "10px",
                        }}
                      >
                        <Autocomplete
                          error={
                            state.errorStatus.hsnCode === true ? true : false
                          }
                          disablePortal
                          id="HSN CODE"
                          name="hsnCode"
                          placeholder="HSN Code"
                          disableClearable
                          options={filterHSN}
                          isOptionEqualToValue={(option, value) =>
                            option.value == value.value
                          }
                          onInputChange={(e, value) => {
                            if (value.length >= 3) {
                              setSearchValue(value.length);
                              searchSAC(value);
                            }
                          }}
                          value={state.hsnCode}
                          onChange={(e, newValue) => {
                            if (newValue == "") {
                              setState((prev) => ({
                                ...prev,
                                hsnCode: newValue,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  hsnCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  hsnCode: "HSN Code is required",
                                },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                hsnCode: newValue,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  hsnCode: true,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  hsnCode: "",
                                },
                              }));
                            }
                          }}
                          sx={{
                            ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                            {
                              paddingBottom: "5px",
                            },
                            ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                            {
                              paddingTop: "6px",
                              paddingBottom: "5px",
                              paddingLeft: "6px",
                            },
                          }}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                {
                                  padding: "8.5px 7px",
                                },
                                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                {
                                  fontSize: "14px",
                                },
                                label: {
                                  fontSize: "14px",
                                },
                                ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                {
                                  fontSize: "14px",
                                },
                                ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                {
                                  color: "input.font",
                                },
                                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "input.border",
                                },
                                ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                {
                                  color: "input.font",
                                },
                                ".css-14qz1ij-MuiListItemText-root": {
                                  margin: "0px",
                                },
                                ".css-wgai2y-MuiFormLabel-asterisk": {
                                  color: "danger.main",
                                },
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="HSN Code"
                            />
                          )}
                        />
                        {searchValue < 3 &&
                          state.errorStatus.hsnCode !== true ? (
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "primary.main",
                            }}
                          >
                            Use atleast 3 characters
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.hsnCode}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={
                            state.errorStatus.gstrate === true ? true : false
                          }
                          select
                          name="gstrate"
                          label="GST Rate"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={state.gstrate}
                          onChange={(e) => {
                            const name = e.target.name;
                            const value = e.target.value;

                            if (value != "addgstrate") {
                              if (value === "") {
                                setState((prev) => ({
                                  ...prev,
                                  ["gstrate"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["gstrate"]: true,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["gstrate"]: "GST Rate is required",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  ["gstrate"]: value,
                                  ["errorStatus"]: {
                                    ...prev.errorStatus,
                                    ["gstrate"]: false,
                                  },
                                  ["errorFields"]: {
                                    ...prev.errorFields,
                                    ["gstrate"]: "",
                                  },
                                }));
                              }
                            }
                          }}
                          sx={{
                            ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                            {
                              fontSize: "14px",
                            },
                            label: {
                              fontSize: "14px",
                            },
                            ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                              fontSize: "14px",
                            },
                            ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              color: "input.font",
                            },
                            ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                              borderColor: "input.border",
                            },
                            ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              color: "input.font",
                            },
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        >
                          {[
                            { id: 0, rate: "0%" },
                            { id: 5, rate: "5%" },
                            { id: 12, rate: "12%" },
                            { id: 18, rate: "18%" },
                            { id: 28, rate: "28%" },
                          ]?.map((item, ind) => {
                            return (
                              <MenuItem key={item.id} value={`${item.id}`}>
                                <ListItemText
                                  sx={{ margin: "0px" }}
                                  primary={item.rate}
                                />
                              </MenuItem>
                            );
                          })}
                          <MenuItem
                            value={"addgstrate"}
                          // onClick={() => setUnitModal(true)}
                          >
                            <SettingsIcon
                              fontSize="small"
                              sx={{ marginRight: "5px" }}
                            />
                            <ListItemText
                              primary={"Add GST Rate"}
                            />
                          </MenuItem>
                        </TextField>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.gstrate}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <Box
                          sx={{
                            position: "relative",
                            border: "solid 1px",
                            borderColor:
                              state.errorStatus.cessType === true
                                ? "danger.main"
                                : "input.border",
                            borderRadius: "4px",
                            padding: "10px 14px",
                            ".css-ahj2mt-MuiTypography-root": {
                              fontSize: "12px",
                              color: "input.font",
                            },
                            ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                              padding: "0px",
                              margin: "0px 5px",
                            },
                            ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                              padding: "0px",
                              margin: "0px 5px",
                              color: "input.border",
                            },
                            ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked":
                            {
                              color: "primary.main",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.75em",
                              letterSpacing: "0.00938em",
                              position: "absolute",
                              top: "-10px",
                              left: "9px",
                              background: "#fff",
                              padding: "0px 3px",
                              color:
                                state.errorStatus.cessType === true
                                  ? "danger.main"
                                  : "input.label",
                            }}
                          >
                            GST compensation Cess Type{" "}
                            <span style={{ color: "#e55353" }}>*</span>
                          </Typography>

                          <RadioGroup
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "row", sm: "row" },
                            }}
                            name="cessType"
                            value={state.cessType}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setState((prev) => ({
                                  ...prev,
                                  cessType: value,

                                  errorStatus: {
                                    ...prev.errorStatus,
                                    cessType: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    cessType:
                                      "Please Select GST Compensation  Type",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  cessType: value,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    cessType: false,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    cessType: "",
                                  },
                                }));
                              }
                            }}
                          >
                            <FormControlLabel
                              value="Percentage"
                              control={<Radio size="small" disableRipple />}
                              label="Percentage"
                            />
                            <FormControlLabel
                              value="Amount"
                              control={<Radio size="small" />}
                              label="Amount"
                            />
                          </RadioGroup>
                        </Box>
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state.errorFields.cessType}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                        <TextField
                          error={state.errorStatus.cess == true ? true : false}
                          label="Cess"
                          name="cess"
                          id="Cess"
                          value={state.cess}
                          fullWidth
                          onChange={(e) => handleChange(e)}
                          size="small"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                {state.cessType == "Percentage" ? "%" : "₹"}
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            ".css-wgai2y-MuiFormLabel-asterisk": {
                              color: "danger.main",
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            marginTop: "2px",
                            marginLeft: "10px",
                            marginBottom: "0px",
                            fontSize: "11px",
                            color: "danger.main",
                          }}
                        >
                          {state?.errorFields.cess}
                        </Typography>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}
            </Box>

            <Box
              sx={{
                // padding : "15px",
                // width:'100%',
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                disableRipple={true}
                onClick={saveChanges}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                ADD
              </LoadingButton>
            </Box>
          </Box>
        </Fade>
      </Modal>
      <AddPartyModal
        open={openPartyModal}
        setOpen={setOpenPartyModal}
        partyType={partyType}
        partyName={partyName}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarText={setSnakbarText}
        page="AccountModal"
        setNeedDashBoardRender={setNewAccID}
      />
      <AddBankAccount
        open={openBankModal}
        setOpen={setOpenBakModal}
        accountName={accName}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarText={setSnakbarText}
        setWarningSnakbar={setWarningSnakbar}
        setWarningText={setWarningText}
        paymentMethod={
          msg == "Payment"
            ? "PaidTo"
            : msg == "Receipt"
              ? "ReceivedFrom"
              : "InvoiceToAccount"
        }
        itemEntry={itemEntry}
        setState1={setState1}
        msg={msg}
        companyDetails={companyData}
        setNewAccID={setNewAccID}
      />
    </Box>
  );
};

export default AddToAccount;
